<script setup>
import { Avatar } from '@dashhudson/dashing-ui/avatar';
import { Card } from '@dashhudson/dashing-ui/card';
import { Chip } from '@dashhudson/dashing-ui/chip';
import { computed } from 'vue';

import AttachmentGroup from '@/app/community/components/AttachmentGroup.vue';
import MessageText from '@/app/community/components/MessageText.vue';
import { attachmentFormatter } from '@/app/community/utils/comments';

const props = defineProps({
  media: { type: Object, default: undefined },
  attachments: { type: Array, default: undefined },
  avatar: { type: String, default: undefined },
  authorName: { type: String, default: undefined },
  text: { type: String, default: undefined },
  severity: { type: String, default: 'active' },
});

const isDeleted = computed(() => props.media?.status === 1);
const formattedAttachments = computed(() => attachmentFormatter(props.attachments ?? []));
</script>

<template>
  <Card :severity="severity" class="dash-p-4 dash-text-base">
    <div class="dash-flex dash-flex-col dash-gap-2">
      <slot name="author">
        <div class="dash-flex dash-items-center dash-gap-2">
          <Avatar :image="avatar" size="sm" />
          <span class="author-name dash-text-primary dash-typo-base-medium">{{ authorName }}</span>
          <Chip
            v-if="isDeleted"
            v-dash-tooltip="'This Tweet was deleted by its author'"
            label="Deleted"
            size="sm"
          />
        </div>
      </slot>
      <slot class="text">
        <MessageText :text="text" />
      </slot>
      <slot name="attachments">
        <AttachmentGroup :attachments="formattedAttachments" />
      </slot>
    </div>
  </Card>
</template>
